import AWSAccountRequest from '../models/entities/AWSAccountRequest';
import { RequestAWSAccountModel } from '../models/viewModels/AWSAccounts/RequestAWSAccountModel';
import { UpdateAccountRequestFieldsModel } from '../models/viewModels/AWSAccounts/UpdateAccountRequestFieldsModel';
import { PermissionSetsResponse } from '../models/viewModels/AWSAccounts/PermissionSetsResponse';
import ApiClient from './ApiClient';

export default class AWSAccountsService extends ApiClient {

    async getAccounts() {
        return this.get<AWSAccountRequest[]>(`AwsAccountRequests`);
    }

    async getMyAccounts() {
        return this.get<AWSAccountRequest[]>(`AwsAccountRequests/me`);
    }

    async getMyApprovals() {
        return this.get<AWSAccountRequest[]>(`AwsAccountRequests/myApprovals`);
    }

    async getById(id: number) {
        return this.get<AWSAccountRequest>(`AwsAccountRequests/${id}`);
    }

    async submitAccountRequest(accountRequest: RequestAWSAccountModel) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/`, accountRequest);
    }

    async updateAccountRequestVpc(accountRequest: any, id: number) {
        return this.patch<AWSAccountRequest>(`AwsAccountRequests/${id}/vpc`, accountRequest);
    }

    async updateAccountRequest(accountRequest: UpdateAccountRequestFieldsModel, id: number) {
        return this.patch<AWSAccountRequest>(`AwsAccountRequests/${id}`, accountRequest);
    }

    async approveAccountRequest(reason: string, id: number) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/${id}/approve`, { reason });
    }

    async completeAccountRequest(reason: string, id: number) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/${id}/complete`, { reason });
    }

    async rejectAccountRequest(reason: string, id: number) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/${id}/reject`, { reason });
    }

    async cancelAccountRequest(reason: string, id: number) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/${id}/cancel`, { reason });
    }

    async deleteAccountRequest(reason: string, id: number) {
        return this.delete<AWSAccountRequest>(`AwsAccountRequests/${id}/requestDelete`, { reason });
    }

    async transferOwnership(accountRequest: any, id: number) {
        return this.post<AWSAccountRequest>(`AwsAccountRequests/${id}/transferOwnership`, accountRequest);
    }

    async getPermissionSets(isManaged: boolean) {
        return this.get<PermissionSetsResponse>(`AwsAccountRequests/permissionSets?isManaged=${isManaged}`);
    }

    async extendPoc(id: number, pocDurationDays: number, reason: string) {
        return this.patch<AWSAccountRequest>(`AwsAccountRequests/${id}/extendpoc`, { pocDurationDays, reason });
    }

    async getFeatureFlags() {
        return this.get<{
            enableNotImportedAccountModifications: boolean;
            enableImportedAccountModifications: boolean;
            enableNotImportedAccountGroupModifications: boolean;
            enableImportedAccountGroupModifications: boolean;
            enableNotImportedAccountTransfers: boolean;
            enableImportedAccountTransfers: boolean;
            enableAwsAccountDeletion: boolean;
            enableAwsPOCAccountRenewal: boolean;
            enableAwsTier0Import: boolean;
            enableAwsTier0Creation: boolean;
            enableAwsCyberCriticalCreation: boolean;
        }>(`AwsAccountRequests/featureFlags`);
    }
}
